import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { AqmAgentReportStateModel } from 'src/core/models/aqm/aqm-agent-report.state-model';
import { ActiveTabChange } from 'src/core/actions/aqm/aqm-agent-report.actions';
import { UserStateSettingsService } from 'src/core/services/state/user-state-settings.service';
import { GenericState } from '../generic/generic.state';

const name = 'AqmAgentReportState';

@State<AqmAgentReportStateModel>({
  name: name,
  defaults: {
    activeTab: 1,
  },
})
@Injectable()
export class AqmAgentReportState extends GenericState<AqmAgentReportState> {
  @Selector()
  static getActiveTab(state: AqmAgentReportStateModel): number {
    return state.activeTab;
  }

  @Action(ActiveTabChange)
  changeActiveTab(ctx: StateContext<AqmAgentReportStateModel>, action: ActiveTabChange) {
    const currentState = ctx.getState();
    currentState.activeTab = action.activeTab;
    this.userSettingsService.patchState(ctx, currentState, name);
  }

  constructor(userSettingsService: UserStateSettingsService) {
    super(userSettingsService);
    this.name = name;

    this.userSettingsService.register(this.name, this);
  }
}
